import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { AI_DATA } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import './NoLimits.scss';

export const OnboardingReplikaNoLimits: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'No Limits',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <OnboardingPage
      className="onboarding-no-limits"
      bgImage={
        <img
          src={AI_DATA[webCampaign.aiType].noLimit.bgImageSrc}
          alt="No Limit"
        />
      }
    >
      <div className="onboarding-no-limits__content">
        <OnboardingTitle color="black">There is no limit</OnboardingTitle>
        <OnboardingSubtitle
          color="neutral-black"
          className="onboarding-no-limits__subtitle"
        >
          Characters are here 24/7, always available to talk and to listen and
          up for anything you would like
        </OnboardingSubtitle>
      </div>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
